import { render, staticRenderFns } from "./OwalForm.vue?vue&type=template&id=f795e1ea&scoped=true"
import script from "./OwalForm.vue?vue&type=script&lang=js"
export * from "./OwalForm.vue?vue&type=script&lang=js"
import style0 from "./OwalForm.vue?vue&type=style&index=0&id=f795e1ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../owal/js/cameras/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f795e1ea",
  null
  
)

export default component.exports